import React from "react";
import { Box, Link } from "@commonsku/design-system";
import { useIdentity } from "../../../hooks";
import { getTasksDashboardUrl } from "./dashboardUrl";

export interface ViewAllTasksLinkProps {
  total: number;
}

/** Footer link shown once there are more tasks than the dropdown displays. */
const ViewAllTasksLink = ({ total }: ViewAllTasksLinkProps) => {
  const identity = useIdentity();

  return (
    <Box
      paddingX="2"
      paddingY="1.5"
      borderTopWidth="1px"
      borderTopColor="border.muted"
      textAlign="center"
    >
      <Link href={getTasksDashboardUrl(identity)} fontSize="sm" fontWeight="bold">
        View All Tasks ({total})
      </Link>
    </Box>
  );
};

export default ViewAllTasksLink;
